import { defineStore } from "pinia";
import { ref } from "vue";

export const useTooltipStore = defineStore("tooltip", () => {
  const visible = ref(false);
  const location = ref({ x: 0, y: 0 });
  const text = ref("");

  function show(x: number, y: number, newText: string) {
    location.value = { x, y };
    text.value = newText;
    visible.value = true;
  }

  function hide() {
    visible.value = false;
  }

  return { show, hide, visible, location, text };
});

export function show(x: number, y: number, text: string) {
  const store = useTooltipStore();
  store.show(x, y, text);
}

export function hide() {
  const store = useTooltipStore();
  store.hide();
}
